import { CustomerProfile as CustomerProfileType } from '../types/index.js';

interface Props {
  profile: CustomerProfileType;
  networkName: string;
}

export function CustomerProfile({ profile, networkName }: Props) {
  return (
    <aside className="customer-profile">
      <div className="profile-header">
        <div className="profile-avatar">{profile.name.split(' ').map((n) => n[0]).join('')}</div>
        <div>
          <h2 className="profile-name">{profile.name}</h2>
          <p className="profile-sub">{profile.profession} · {profile.age} yrs</p>
        </div>
      </div>

      <div className="profile-badge">
        <span className="badge-network">{networkName}</span>
      </div>

      <dl className="profile-details">
        <dt>Location</dt>
        <dd>{profile.location}</dd>

        <dt>Monthly Spend</dt>
        <dd>${profile.typicalMonthlySpend.toLocaleString()} AUD avg</dd>

        <dt>Travel</dt>
        <dd>{profile.travelFrequency}</dd>

        <dt>Usual Merchants</dt>
        <dd>
          <div className="merchant-tags">
            {profile.commonMerchants.map((m) => (
              <span key={m} className="merchant-tag">{m}</span>
            ))}
          </div>
        </dd>
      </dl>
    </aside>
  );
}
